import { createRouter, createWebHashHistory } from "vue-router";
import { useUserStore } from "@/store/userStore";

const routes = [
  {
    path: "/",
    name: "appshell",
    redirect: "/home",
    component: () => import("../views/appShell.vue"),
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("../views/homeView.vue"),
        meta: {
          requiresAuth: true,
          desc: "Inicio",
        },
      },
      {
        path: "ica",
        name: "ica",
        redirect: "/ica/list",
        component: () => import("../views/ica/icaView.vue"),
        meta: {
          requiresAuth: true,
          desc: "ICA",
        },
        children: [
          {
            path: "list",
            name: "ica_list",
            component: () => import("../views/ica/icaListView.vue"),
          },
          {
            path: "reg/:uuid",
            name: "ica_reg",
            component: () => import("../views/ica/icaRegView.vue"),
          },
          {
            path: "start",
            name: "ica_start",
            component: () => import("../views/ica/icaStartView.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/loginView.vue"),
    meta: {
      desc: "Login",
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/logoutView.vue"),
    meta: {
      desc: "Logout",
    },
  },
  {
    path: "/noaccess",
    name: "noaccess",
    component: () => import("../views/noaccessView.vue"),
    meta: {
      desc: "Noaccess",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "nofound",
    component: () => import("../views/nofoundView.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to) => {
  const userStore = useUserStore();
  if (to.meta.requiresAuth && !userStore.uid) return "/login";
});

export default router;
